<template>
  <div class="category">
  <sidebar class="left" :list="sidebar" @seleced="seleced" :activeIndex="sidebarIndex"></sidebar>
  <div class="right">
    <vant-list
      v-model="loading"
      :finished:="finished"
      finished-text="没有更多了"
      @load="getList"
      >
    <goods :goodsInfo="goodsList" ref="goodsList"></goods>
  </vant-list>
  </div>

    <!-- <cate :list="rightSidebarList" class="right"></cate> -->
</div>
</template>
<script>
import { getCategory, goodsList } from '@/api/goods'
import { List } from 'vant'

// import scroll from '@/mixins/scroll'


import { sidebar, goods } from "./components";


export default {
  components: {
    sidebar,
    [List.name]: List,
    goods
  },
  data () {
    return {
      sidebar: [],
      sidebarIndex: 0,
      goodsList: [],
      rightSidebarList: [],
      finished: false,
      loading: false,
      page: 0
    }
  },
  methods: {
    scroll (e) {
      console.log(e);
    },
    // 选中侧边栏 id
    seleced (id) {
      this.sidebarIndex = id
      this.page = 0
      this.goodsList = []
      this.finished = false
      this.getList()
      console.log(this.$refs['goodsList'].$el.scrollTop)
     this.$refs['goodsList'].$el.scrollTo(0)
    },
    //获取商品列表
    async getList () {
      this.page++;
      this.loading = true;
      const result = await goodsList({
        page: this.page,
        size: 25,
        first_cat_id: this.sidebarIndex
      }).catch(() => this.loading = false);
      this.loading = false;
      try {
        if (result.data.data.goodsList.data.length !== 0) {
          this.goodsList = result.data.data.goodsList.data
        } else {
          this.finished = true
        }
      } catch (err) { }

    },

    // // 获取一级分类
    async getCategory (grade = 1) {
      const result = await getCategory({
        grade: grade,
        parent_id: grade === 2 ? this.sidebarIndex : 0
      })
      const data = result.data.data
      if (data.status) {
        if (grade === 1) {
          this.page = 0
          this.sidebarIndex = data.cartList[0].cat_id
          this.sidebar = data.cartList
          // this.finished = false
          this.getList()
          // this.goodsList = []
          // this.getCategory(2)
        }
        if (grade === 2) {
          this.rightSidebarList = data.cartList
        }
      }
    },
  },
  created () {
    this.getCategory()
    // this.getList()
  },
  activated () {
    // this.page = 1
    // this.goodsList = []
    // this.getList()
  }
}
</script>
<style lang="scss" scoped>
.category {
  margin: 0.1rem 0;
  .left {
    width: 30vw;
  }
  .right {
    width: 70vw;
    position: absolute;
    background: #fff;
    right: 0;
    height: 100vh;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  }
}
</style>